export default __webpack_public_path__ + "static/metabolic_card_mobile-b34da05bdd983842837befd0824d773a.png";